import React from 'react';
import SamplingBox from './SamplingBox';
import SignalsBox from './SignalsBox';
import StimuliBox from './StimuliBox';
import EventsBox from './EventsBox';

const DataExportationParameters = props => {
  return [
    <SamplingBox key="sampling" />,
    <SignalsBox key="signals" />,
    <StimuliBox key="stimuli" />,
    <EventsBox key="events" />
  ];
};

export default DataExportationParameters;



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/parameters/DataExportationParameters.js